import React, { useState, useEffect } from "react";

const IosQuestions = ({ handleSelect, selectedRegions, questionKey }) => {
  const [values, setValues] = useState({
    redness: "", swelling: "", oozing: "", scratch: "", thickness: "", dryness: "",
  });

  useEffect(() => {
    setValues({ redness: "", swelling: "", oozing: "", scratch: "", thickness: "", dryness: "" });
  }, [questionKey]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((prev) => ({ ...prev, [name]: value }));
    handleSelect({ [name]: value });
  };

  const SIGNS = [
    { name: "redness", label: "Redness" },
    { name: "swelling", label: "Swelling" },
    { name: "oozing", label: "Oozing/Crusting" },
    { name: "scratch", label: "Scratch Marks" },
    { name: "thickness", label: "Thickness" },
    { name: "dryness", label: "Dryness" },
  ];

  return (
    <div className="ios-box">
      <h2 className="ios-title">How would you rate the intensity of signs of the affected area?</h2>
      <p className="ios-hint">0 = None &nbsp; 1 = Mild &nbsp; 2 = Moderate &nbsp; 3 = Severe</p>
      <table className="ios-table">
        <thead>
          <tr>
            <th></th>
            {[0, 1, 2, 3].map((v) => <th key={v}>{v}</th>)}
          </tr>
        </thead>
        <tbody>
          {SIGNS.map(({ name, label }) => (
            <tr key={name}>
              <td className="ios-sign-label">{label}</td>
              {[0, 1, 2, 3].map((v) => (
                <td key={v}>
                  <input
                    type="radio"
                    name={name}
                    value={String(v)}
                    checked={values[name] === String(v)}
                    onChange={handleChange}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default IosQuestions;
